define("powergen/models/score",
  [],
  function() {
    "use strict";
    var Score;

    Score = DS.Model.extend({
      firstName: DS.attr('string'),
      lastName: DS.attr('string'),
      email: DS.attr('string'),
      score: DS.attr('number'),
      active: DS.attr('boolean'),
      activeObserver: (function() {
        return $.ajax({
          method: 'PUT',
          url: '/api/score/' + this.get('id'),
          data: {
            active: this.get('active')
          }
        });
      }).observes('active')
    });


    return Score;
  });